import { IconPropsType } from './types/IconsProps.type';

type IconHomeEyeProps = & IconPropsType

export const HomeEyeIcon = ({
    width = 20,
    height = 20,
    className = '',
    style = {},
    fillColor = 'currentColor',
}: IconHomeEyeProps) => {
    return (
        <svg
            width={width}
            height={height}
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={className}
            style={style}
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M10.2158 3.91704C10.0913 3.80586 9.90898 3.80586 9.78452 3.91704L3.95119 9.12829C3.87794 9.19373 3.8335 9.29085 3.8335 9.39572V15.8162C3.8335 16.0198 3.99247 16.167 4.16683 16.167H15.8335C16.0079 16.167 16.1668 16.0198 16.1668 15.8162V9.39572C16.1668 9.29085 16.1224 9.19373 16.0491 9.12829L10.2158 3.91704ZM9.1183 3.17129C9.62222 2.72111 10.3781 2.72111 10.882 3.17129L16.7154 8.38254C17.0038 8.64022 17.1668 9.0099 17.1668 9.39572V15.8162C17.1668 16.5524 16.5796 17.167 15.8335 17.167H4.16683C3.42071 17.167 2.8335 16.5524 2.8335 15.8162V9.39572C2.8335 9.0099 2.99652 8.64022 3.28496 8.38254L9.1183 3.17129Z"
                fill={fillColor}
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M7.11226 12.2732C6.98769 12.0288 6.68903 11.9302 6.44322 12.0531C6.19623 12.1766 6.09612 12.4769 6.21961 12.7239L6.22018 12.7251L6.22083 12.7263L6.22237 12.7294L6.22645 12.7372C6.22962 12.7433 6.23369 12.7509 6.23869 12.76C6.24869 12.7782 6.26242 12.8023 6.28012 12.8314C6.3155 12.8897 6.36688 12.9684 6.4361 13.0607C6.57438 13.2451 6.78527 13.4854 7.08365 13.7241C7.68674 14.2066 8.6287 14.667 10.0002 14.667C11.3716 14.667 12.3136 14.2066 12.9167 13.7241C13.2151 13.4854 13.4259 13.2451 13.5642 13.0607C13.6334 12.9684 13.6848 12.8897 13.7202 12.8314C13.7379 12.8023 13.7516 12.7782 13.7616 12.76C13.7666 12.7509 13.7707 12.7433 13.7739 12.7372L13.778 12.7294L13.7795 12.7263L13.7801 12.7251C13.7809 12.7235 13.7807 12.7239 13.7807 12.7239C13.9042 12.4769 13.8041 12.1766 13.5571 12.0531C13.3113 11.9302 13.0126 12.0288 12.8881 12.2732L12.8854 12.2781C12.882 12.2843 12.8754 12.296 12.8654 12.3125C12.8454 12.3453 12.8122 12.3968 12.7642 12.4607C12.6681 12.5889 12.5144 12.7653 12.292 12.9432C11.8534 13.2941 11.1287 13.667 10.0002 13.667C8.87162 13.667 8.14691 13.2941 7.70834 12.9432C7.48589 12.7653 7.33219 12.5889 7.2361 12.4607C7.18813 12.3968 7.15488 12.3453 7.13491 12.3125C7.12494 12.296 7.11833 12.2843 7.1149 12.2781L7.11226 12.2732Z"
                fill={fillColor}
            />
        </svg>
    );
};

